<template>
  <div class="c-baby-brief">
    <div class="c-baby-brief__content">
      <ul class="baby-info-list">

        <!-- {{formatBabyInfo['dueDate']}} -->
        <li class="baby-info-list__item" v-for="item of keyList" :key="item.key">
          <p class="data-row">
            <span class="data-row__label">{{ item.label }}：</span>
            <span class="data-row__data">{{ formatBabyInfo[item.key] }}</span>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'BabyBrief',
  props: {
    babyInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const keyList = [
      {
        key: 'dueDate',
        label: '預產期',
      },
      {
        key: 'birthday',
        label: '出生日期',
      },
      {
        key: 'hospitalName',
        label: '出生醫院',
      },
      {
        key: 'week',
        label: '出生週數',
      },
      {
        key: 'weightGm',
        label: '出生體重',
      },
    ];

    const formatBabyInfo = computed(() => ({
      dueDate: props.babyInfo.due_date,
      birthday: props.babyInfo.birthday,
      hospitalName: props.babyInfo.hospital?.name || props.babyInfo.hospital_name,
      week: props.babyInfo.week,
      weightGm: props.babyInfo.weight_gm,
    }));

    return {
      formatBabyInfo,
      keyList,
    };
  },
});
</script>
<style lang="scss" scoped>
.c-baby-brief {
  margin-top: 10px;
  margin-bottom: 30px;

  &__content {
    @include padding(10px 34px);
    background-color: rgba($c-table-row-stripe, 0.2);
    border-radius: 20px;

  }
}

.baby-info-list {

  &__item {
    &+& {
      margin-top: 10px;
    }
  }
}

.data-row {

  &__label {
    @include font-normal($c-main, 16, 700);
  }

  &__data {
    @include font-normal();
  }

}
</style>
